import liana_testimonial from '../../../custom_assets/home/testimonials/liana_testimonial.png'
import jonathan_testimonial from '../../../custom_assets/home/testimonials/jonathan_testimonial.png'
import alex_testimonial from '../../../custom_assets/home/testimonials/alex_testimonial.png'
import kristina_testimonial from '../../../custom_assets/home/testimonials/kristina_testimonial.png'

const testimonial = (testimonial) => {
  return <div className="dca-home-testimonial-wrapper">
    {testimonial.image && <img src={testimonial.image} alt={testimonial.imageAlt} className="dca-home-testimonial-image"></img>}

    <span className="dca-home-testimonial-source-wrapper">
      <span className="dca-home-testimonial-name">{testimonial.name},</span>
      <span className="dca-home-testimonial-name">{testimonial.role}</span>
    </span>

    <span className="dca-home-testimonial-text">{testimonial.text}</span>
  </div>
}

export const Testimonials = () => {

  // let testimonialX = {
  //   image:,
  //   imageAlt: ``,
  //   name: ``,
  //   role: ``,
  //   text: ``
  // }

  let testimonial1 = {
    image: liana_testimonial,
    imageAlt: `liana_columbia_university_student`,
    name: `Liana`,
    role: `Columbia University student`,
    text: `“I love how data-driven the service is with so many insightful tools, proprietary analytics and cool visualizations. NextFour should be the definitive starting point for all high school students applying to the top colleges!”`
  }

  let testimonial2 = {
    image: jonathan_testimonial,
    imageAlt: `jonathan_high_school_student`,
    name: `Jonathan`,
    role: `High school student`,
    text: `“Very impressive set of helpful resources for aspiring college applicants, all consolidated into one easy-to-use product. I've tried a bunch of online solutions before, but nothing compares to this service. Highly recommended!”`
  }

  let testimonial3 = {
    image: alex_testimonial,
    imageAlt: `alex_parent`,
    name: `Alex`,
    role: `Parent`,
    text: `“We know firsthand just how important it is to be strategic throughout the college application process - from picking majors, selecting EC activities, building a college list, etc. NextFour will be immensely helpful to families as they navigate all those critical decisions through high school.”`
  }

  let testimonial4 = {
    image: kristina_testimonial,
    imageAlt: `kristina_stanford_university_admit`,
    name: `Kristina`,
    role: `Stanford University admit`,
    text: `“NextFour is truly amazing! It's bringing the power of technology and innovation to the world of college admissions. The insights I got from NextFour were super helpful in shaping my application strategy, and I was so thrilled to end up getting into my dream school!"`
  }

  return <div className="dca-home-testimonials-wrapper">
    <div className="dca-home-testimonial-row" style={{ marginBottom: window.innerWidth <= 768 ? '' : '90px' }}>
      {testimonial(testimonial1)}

      {testimonial(testimonial2)}
    </div>

    <div className="dca-home-testimonial-row">
      {testimonial(testimonial3)}

      {testimonial(testimonial4)}
    </div>
  </div>
}